import { restClient } from '../../client';


export type SupervisionMeetingMethod = 'video' | 'phone' | 'in_person';

export type SupervisionMeeting = {
  id: string;
  collaborativePhysicianId: string;
  superviseeId: string;
  stateId: string;
  meetingDate: string; // ISO date "YYYY-MM-DD"
  durationMinutes: number;
  method: SupervisionMeetingMethod;
  summary: string;
  createdAt: string; // ISO datetime
  submittedAt: string | null;
};


export type CreateSupervisionMeetingBody = {
  meetingDate: string; // "YYYY-MM-DD"
  durationMinutes: number;
  method: SupervisionMeetingMethod;
  summary: string;
};

export type SupervisionMeetingStats = {
  collaborativeMatchId: string;
  physicianId: string;
  providerId: string;
  stateId: string;
  nextDueDate: string;
};

export const getSupervisionMeetingsStats = (providerId: string) =>
  restClient.request<{ data: SupervisionMeetingStats[] }>(
    `/api/v1/provider/${providerId}/supervision-meetings-stats`
  );

export const getSupervisionMeetings = (providerId: string) =>
  restClient.request<{ data: SupervisionMeeting[] }>(
    `/api/v1/provider/${providerId}/supervision-meetings`
  );

export const getSupervisionMeeting = (meetingId: string) =>
  restClient.request<{ data: SupervisionMeeting }>(
    `/api/v1/supervision-meetings/${meetingId}`
  );

export const createSupervisionMeeting = (
  providerId: string,
  matchId: string,
  body: CreateSupervisionMeetingBody
) =>
  restClient.request<{ data: SupervisionMeeting }>(
    `/api/v1/provider/${providerId}/supervisees/${matchId}/supervision-meetings`,
    {
      method: 'POST',
      data: {
        meeting_date: body.meetingDate,
        duration_minutes: body.durationMinutes,
        method: body.method,
        summary: body.summary,
      },
    }
  );
